module.exports = __webpack_public_path__ + "img/ICS.6b9a8d7d.svg";